import { createRequestHelper } from '@utils/swr'
import { type WpUserProfileNoCacheRequest, type WpUserProfileRequest } from '../types/apiRequest'
import { type WpApis } from '../types/apis'
import { type WpUserProfile } from '../types/dataModel/wpUser'

const userProfilePath = (siteId: number) => `/dni/mu/user/profile?site_id=${siteId}` as const

const {
  useRequest,
} = createRequestHelper<WpApis['get']['userProfile'], WpUserProfile, WpUserProfileRequest>({
  client: 'wpRelay',
  key: params => params?.site_id ? userProfilePath(params.site_id) : null,
})

export const useApiUserProfile = useRequest

const {
  useRequest: useRequestNoCache,
} = createRequestHelper<WpApis['get']['userProfile'], WpUserProfile, WpUserProfileNoCacheRequest>({
  client: 'wpRelay',
  /*
   * 以變動的 _cacheBuster 讓 URL 不同來繞 WKWebView 的快取政策
   * 須經 fetcher 的 params 帶入
   */
  key: params => params?.site_id
    ? `${userProfilePath(params.site_id)}&_cacheBuster=${params._cacheBuster}`
    : null,
  fetcher: client => (url, params) => client.get(url, { params }),
})

export const useApiUserProfileNoCache = useRequestNoCache
